import React, { Component } from 'react';

const RELOAD_KEY = 'chunk_reload';

class LazyErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasLazyError: false };
    // Si llegamos aquí sin error, la carga fue exitosa → limpiar flag
    sessionStorage.removeItem(RELOAD_KEY);
  }

  static getDerivedStateFromError(error) {
    if (
      error.message &&
      error.message.toLowerCase().includes('loading chunk')
    ) {
      return { hasLazyError: true };
    }
    return null;
  }

  componentDidCatch(error) {
    if (
      error.message &&
      error.message.toLowerCase().includes('loading chunk')
    ) {
      const lastReload = sessionStorage.getItem(RELOAD_KEY);
      const now = Date.now();
      if (!lastReload || now - Number(lastReload) > 10000) {
        sessionStorage.setItem(RELOAD_KEY, String(now));
        window.location.reload();
      }
    }
  }

  render() {
    const { hasLazyError } = this.state;
    const { children } = this.props;

    if (hasLazyError) {
      return (
        <h2>
          Falló al cargar la página. Verifica tu conexión a internet y vuelve a
          intentar
        </h2>
      );
    }

    return children;
  }
}

export default LazyErrorBoundary;
